module.exports = __webpack_public_path__ + "static/media/iphone-mockup-digital-therapy.227e14b0.png";